appExperimente.controller('SellsCardController', ['$rootScope', '$scope', '$http', '$window', '$filter', function ($rootScope, $scope, $http, $window, $filter) {

  $scope.LOADING = $scope.hasActiveEstablishment();
  $scope.chartist = null;
  $scope.produtoSelecionado = null;
  $scope.data = null;
  $scope.produtos = null;
  $scope.sellsCurrentStep = 0;
  $scope.lastUsedElementSelector = null;

  $scope.toggleTip = function (elementSelector) {
    $scope.lastUsedElementSelector = elementSelector;
    if ($scope.sellsCurrentStep !== 1) {
      $scope.sellsCurrentStep = 1;
      $scope.markElement(elementSelector, 'tour-element-active-gray');
    } else {
      $scope.sellsCurrentStep = 0;
      $scope.unmarkElement(elementSelector, 'tour-element-active-gray');
    }
  };

  $scope.$on(constants.EVENTS.TUTORIAL_START, function () {
    $scope.sellsCurrentStep = 0;
    $scope.unmarkElement($scope.lastUsedElementSelector, 'tour-element-active-gray');
  });

  $scope.sellsTipContent = [{
    items: [
      'Aqui você acompanha como estão suas vendas para cada produto VR Benefícios.',
      'Veja o valor acumulado de suas vendas nas últimas 4 semanas e também a média semanal.',
      'Para ver o valor da venda de cada semana, clique na bolinha da semana correspondente.',
      'Obs.: As semanas são de domingo a sábado, sendo apresentado o dia de domingo como o primeiro dia da semana.'
    ]
  }];

  $scope.$on(constants.EVENTS.ESTABLISHMENT_UPDATED, function (event) {
    $scope.chartist = null;
    $scope.data = null;
    $scope.produtos = null;
    $scope.init();
  });

  $scope.hasProduct = function () {
    return $scope.produtos !== null && $scope.produtos.length > 0 && $scope.LOADING === false;
  };

  $scope.hasContent = function () {
    return $scope.chartist !== null && $scope.data !== null && $scope.LOADING === false;
  };

  $scope.hasNoContent = function () {
    return $scope.chartist === null && $scope.data === null && $scope.LOADING === false || !$scope.hasActiveEstablishment();
  };

  $scope.init = function () {
    if ($rootScope.hasActiveEstablishment()) {
      $scope.LOADING = true;
      $http({
        method: 'GET',
        url: '/portal/app/UI-Comum/trial/ec/cadastro/consultar-credenciamento',
        headers: {'Content-Type': 'text/plain'}
      }).success(function (data) {
        $scope.LOADING = false;
        $scope.produtos = data;
        if ($scope.produtos !== null) {
          $scope.produtoSelecionado = $scope.produtos[0].id;
          if ($scope.hasActiveEstablishment()) {
            $scope.consultar($scope.produtoSelecionado);
          }
        }
      })
      .error(function (data) {
        $scope.LOADING = false;
        $scope.produtos = [];
      });
    }
  };

  $scope.consultar = function () {
    $scope.LOADING = true;
    $scope.chartist = null;
    $http({
      method: 'GET',
      url: '/portal/app/UI-Comum/trial/ec/venda/resumo/' + $scope.produtoSelecionado,
      headers: {'Content-Type': 'text/plain'}
    }).success(function (data) {
      $scope.LOADING = false;
      $scope.resumoVendas = data;
      $scope.plotarGrafico();
    }).error(function () {
      $scope.LOADING = false;
      $scope.resumoVendas = null;
      $scope.data = null;
    });
    return false;
  };

  $scope.plotarGrafico = function () {
    if ($scope.hasActiveEstablishment()) {
      $scope.data = {
        value: $filter('currency')($scope.resumoVendas.valorTotalVendas, 'R$ '),
        weeklyMean: $filter('currency')($scope.resumoVendas.mediaSemanal, 'R$ ')
      };

      $scope.chartist = {
        data: {
          labels: [
            $filter('date')($scope.resumoVendas.rotuloSemana1, 'dd MMM'),
            $filter('date')($scope.resumoVendas.rotuloSemana2, 'dd MMM'),
            $filter('date')($scope.resumoVendas.rotuloSemana3, 'dd MMM'),
            $filter('date')($scope.resumoVendas.rotuloSemana4, 'dd MMM'),
          ],
          series: [
            [
              $scope.resumoVendas.valorSemana1,
              $scope.resumoVendas.valorSemana2,
              $scope.resumoVendas.valorSemana3,
              $scope.resumoVendas.valorSemana4
            ]
          ]
        },
        options: {
          low: 0,
          showArea: true,
          stretch: true,
          fullWidth: true,
          axisY: {
            showLabel: false,
            showGrid: false,
            offset: 0
          },
          axisX: {
            showGrid: true
          },
          lineSmooth: Chartist.Interpolation.simple({
            divisor: 3
          }),
          plugins: [
            Chartist.plugins.tooltip({
              tooltipFnc: function (meta, value) {
                return $filter('currency')(value, 'R$ ');
              }
            })
          ]
        }
      };
    }
  };

  $scope.init();

  if (constants.SETTINGS.DEBUG) {
    $scope.exposeScope('SellsCardController', $scope);
  }

}]);
